import { AfterViewInit, Component, Input, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';

import { WindowReference } from 'services/window';
import { Util } from 'core/services';
import { BarChart } from './utils/graph';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'xm-graph',
    styleUrls: ['./graph.scss'],
    templateUrl: './graph.html',
    standalone: false
})
export class GraphComponent implements AfterViewInit, OnInit, OnDestroy {
    @Input() public data: GraphItem[];
    @Input() public theme: string;  // either activity or billing
    @Input() public tooltip: boolean;
    @Input() public format: string;

    public chart: BarChart;
    private element: Renderer2;
    private window: WindowReference;
    private subscriptions: Subscription[] = [];

    constructor(element: Renderer2, window: WindowReference) {
        this.element = element;
        this.window = window;
    }

    public ngOnInit(): void {
        this.data = this.data || [];

        // Always sort from oldest to newest : Don't rely on order of incoming Input
        this.data.sort((item1: GraphItem, item2: GraphItem) => {
            const date1: Date = new Date(item1.date);
            const date2: Date = new Date(item2.date);

            return date1.getTime() - date2.getTime();
        });
    }

    public ngAfterViewInit(): void {
        this.createGraph();

        // subscribe for width watch
        this.subscriptions.push(this.window.windowWidth.subscribe(() => {
            this.chart.update();
        }));
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }

    private createGraph(): void {
        this.chart = new BarChart(this.element.selectRootElement('.svg'), this.data);
        const yaxisSymbol: string = this.theme === 'activity' ? 'GB' : '$';
        this.chart.setYAxisSymbol(yaxisSymbol);
        this.chart.update();
    }
}
